import { gql } from "@apollo/client";

export const CREATE_INVENTORY = gql`
    mutation CreateInventory($input: CreateInventoryInput) {
        createInventory(input: $input) {
            inventory {
                id
                vin
                modelCode
                exteriorColor
                interiorColor
                shipName
                locationStatus
                orderNo
                offlineDate
                fhiDeparture
                vesselEta
                dealerId
                vehicleInfo {
                    retireDate
                    warrantyDate
                    accessories
                    tag
                    description
                    plate
                    make
                    keys
                    bodyStyle
                    year
                    transmission
                    engine
                    driveTrain
                    roof
                    tires
                    oemId
                    shId
                    vmhId
                    star
                    availableDate
                    km
                    fuel
                    isNewModel
                    isPrototype
                    isRedesign
                }
                metadata {
                    createdAt
                    createdBy
                    isOverriddenBySystem
                    isLatestVersion
                    parentVersionId
                }
                additionalData {
                    name
                    value
                }
            }
        }
    }
`;

export const UPDATE_INVENTORY = gql`
    mutation UpdateInventory($input: UpdateInventoryInput) {
        updateInventory(input: $input) {
            inventory {
                id
                vin
                modelCode
                modelTrim
                color
                exteriorColor
                interiorColor
                shipName
                locationStatus
                orderNo
                offlineDate
                fhiDeparture
                vesselEta
                dealerId
                vehicleInfo {
                    retireDate
                    warrantyDate
                    accessories
                    tag
                    description
                    plate
                    make
                    keys
                    bodyStyle
                    year
                    transmission
                    engine
                    driveTrain
                    roof
                    tires
                    oemId
                    shId
                    vmhId
                    star
                    availableDate
                    km
                    fuel
                    isNewModel
                    isPrototype
                    isRedesign
                }
                metadata {
                    createdAt
                    createdBy
                    isOverriddenBySystem
                    isLatestVersion
                    parentVersionId
                }
                additionalData {
                    name
                    value
                }
            }
        }
    }
`;

export const CONVERT_INVENTORY_TO_VEHICLE = gql`
    mutation ConvertToVehicle($input: ConvertToVehicleInput) {
        convertToVehicle(input: $input) {
            id
            vin
            vehicleId
        }
    }
`;